import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { FetchChatResponse } from '../apis/chatApi'
import { sessionTimeout } from './authSlice';

interface Message {
    message?: any;
    msgDateTime?: any;
    ResMsgDateTime?: any;
    fileUploadedTime?: any;
    sender: 'user' | 'api' | 'file';
    typing?: boolean;
    currentModule: string;
    response_type?: string;
    xaxis?: any;
    yaxis?: any;
    files?: any;
}

interface ChatState {
    messages: Message[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
    typingMessage: Message | null;
    files?: any;
}

const initialState: ChatState = {
    messages: [],
    status: 'idle',
    error: null,
    typingMessage: null,
    files: null

}

interface asyncthunkParams {
    msge: string;
    switchStatus: string;
    azuresearchId: any;
}

export const fetchResponse = createAsyncThunk<string, asyncthunkParams>(
    'chat/fetchResponse',
    async ({ msge, switchStatus, azuresearchId }, thunkApi) => {
        try {

            thunkApi.dispatch(sessionTimeout(false))
            // const {azuresearchId}=  (thunkApi.getState() as {auth:AuthState}).auth
            const response = await FetchChatResponse(msge, switchStatus, azuresearchId);
            return response
        }
        catch (error: any) {
            if (error.response?.status === 401) {
                thunkApi.dispatch(sessionTimeout(true))
            }
            return thunkApi.rejectWithValue(JSON.stringify(error.response.data))
        }

    }
)
const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        addMessage: (state, action: PayloadAction<Message>) => {
            if (action.payload.message !== '**loading**') {
                state.messages.push(action.payload)
            }
        },
        setTypingMessage: (state, action: PayloadAction<Message | null>) => {
            state.typingMessage = action.payload
        },
        addUploadedFiles: (state, action: PayloadAction<Message>) => {
            state.messages.push(action.payload)
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchResponse.pending, (state) => {
            state.status = 'loading'
            state.typingMessage = { message: '**loading**', sender: 'api', typing: true, currentModule: 'idm' }
        })
        builder.addCase(fetchResponse.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.payload ? JSON.parse(action.payload as string) : action.error || null
            state.typingMessage = { message: (action.payload ? action.payload : JSON.stringify({ error: action.error.message })), sender: 'api', typing: true, currentModule: 'idm' }
        }).addCase(fetchResponse.fulfilled, (state, action) => {
            state.status = 'succeeded'
            state.typingMessage = { message: action.payload, sender: 'api', typing: true, currentModule: 'idm' }
        })

    }
})




export default chatSlice.reducer

export const { addMessage, setTypingMessage, addUploadedFiles } = chatSlice.actions